// URL DE AMBIENTE APIBPM
const urlEnviroment = 'https://app-sds-transportabilidad-dev-eastus.azurewebsites.net/';

export const environment = {
  production: false,

    urlAPI: `${urlEnviroment}api`,

    //variables para Azure AD
    baseUrl: `${urlEnviroment}api/`,
    postLogoutUrl: '/',
    APP_CLIENT_ID : '6dfed1c9-50b8-49e6-8bd6-09d850f5ccba',
    APP_AUTHORITY : 'https://saludcapitalb2c.b2clogin.com/saludcapitalb2c.onmicrosoft.com/B2C_1_InicioSesionConRegistro',
    APP_REDIRECT_TO : '/',
    APP_ROL_URL: 'Ciudadano.Read',  
        
};
